import { JSXElementConstructor, ReactElement, Ref } from 'react'

import { Select as AntSelect } from 'antd'
import { BaseOptionType, RefSelectProps } from 'antd/es/select'
import { useField, useFormikContext } from 'formik'

import FormGroup from '../FormGroup'
import DefaultFieldProps from '../FormGroup/DefaultFieldProps'

type Item = {
  id: any
  name: string
  disabled?: boolean
}

type FormikFieldProps = DefaultFieldProps & {
  ref?: Ref<RefSelectProps>
  mode?: 'multiple' | 'tags'
  maxTagCount?: number | 'responsive'
  items: Item[]
  size?: 'large' | 'small' | 'middle'
  placeholder?: string
  onChange?: (id: any) => void
  filterOption?: boolean | ((inputValue: string, option: BaseOptionType) => boolean)
  disabled?: boolean
  loading?: boolean
  showSearch?: boolean
  allowClear?: boolean
  className?: string
  dropdownRender?:
    | ((
        menu: ReactElement<any, string | JSXElementConstructor<any>>,
      ) => ReactElement<any, string | JSXElementConstructor<any>>)
    | undefined
}

const SelectV2 = ({ ref, ...props }: FormikFieldProps) => {
  const [field] = useField(props.name)
  const context = useFormikContext()

  return (
    <FormGroup {...props}>
      <AntSelect
        {...props}
        ref={ref}
        value={field.value}
        onChange={(value: any) => {
          context.setFieldValue(props.name, value)
          props.onChange && props.onChange(value)
        }}
        filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
        options={props.items.map((x) => {
          return {
            label: x.name,
            value: x.id,
            disabled: x.disabled,
          }
        })}
      />
    </FormGroup>
  )
}
export default SelectV2
